(ns ui.totp.relation
  "Totp UI to set the relationship to select an totp account and add this
  to an instagram account"
  (:require [storrito.ui.button :as button]
            [storrito.ui.core :as ui]
            [parts.replicant.command :as command]
            [ui.app-frame :as app-frame]
            [parts.replicant.query :as query]
            [ui.totp.core :as core]
            ))

(defn panel
  [state]
  [:div
   {:class "flex justify-center"}
   (let [account-id (:account/id state)
         result (query/get-result state core/totp-query)
         totp-entries (get-in result [:totp :totp/entries])
         command {:command/kind :command/totp-set-relation
                  :command/data {:instagram.user/id account-id
                                 :totp/selected-uuid (:totp/uuid state)}}
         command-action [:data/command
                         command
                         {:on-success [[:store/assoc-in
                                        [:location]
                                        {:location/page-id :pages/totp}]]}]]

     [:div
      {:class "max-w-md"}
      [:label.text-gray-800.block.text-base.font-bold.mb-2.mt-6
       "Select 2FA for your instagram account :"]

      [:div
       [:div.w-full.cursor-pointer.block.max-w-full.bg-white.border-gray-400.rounded.text-gray-800.text-md.outline-none
        {:style {:max-width "400px"}
         :placeholder "Country"
         :required true}

        [:select.w-full
         {:class "mt-1 mb-2 block w-full rounded-md border-gray-300 py-3 pl-3 pr-10 text-base focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
          :name "country"
          :on {:change [[:store/assoc :totp/uuid :event/target.value]]}}

         [:optgroup
          (doall (map
                   (fn [[uuid entries]]
                     [:option.font-semibold
                      {:key (str uuid "-common")
                       :value uuid
                       :placeholder "Please select an TOTP"
                       :selected (= uuid (:totp/uuid state))}
                      (:totp/name entries)])
                   totp-entries))

          [:option
           {:value ""
            :disabled "true"
            :selected "true"
            :hidden "true"}
           "-- Select a 2fa device --"]]]]]

      [:div.mt-4
       (cond
         (command/success? state command)
         [:div.flex.items-center.flex-col.justify-center
          [:div.rounded-md.bg-green-50.p-4
           [:div.flex
            [:div.shrink-0
             [:svg.size-5.text-green-400 {:viewBox "0 0 20 20" :fill "currentColor" :aria-hidden "true" :data-slot "icon"}
              [:path {:fill-rule "evenodd" :d "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.857-9.809a.75.75 0 0 0-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 1 0-1.06 1.061l2.5 2.5a.75.75 0 0 0 1.137-.089l4-5.5Z" :clip-rule "evenodd"}]]]
            [:div.ml-3
             [:p.text-sm.font-medium.text-green-800 "Successfully saved"]]]]
          [:ui/a.link
           {:ui/location
            {:location/page-id :pages/totp
             :location/params {}}
            :class (cons "ml-2"
                         ui/button-secondary)}
           "Continue"]]

         (command/error? state command)
         [:p {:class "text-red-500 text-s italic min-h-8"}
          "ERROR : "
          (command/get-latest-error state
                                    command)]

         ::else
         [:div.flex.items-center.justify-center
          [:button
           {:on {:click [command-action]}
            :disabled (nil? (:totp/uuid state))
            :type "button"
            :class button/button-primary-css}
           "Save"]

          [:ui/a.link
           {:ui/location
            {:location/page-id :pages/totp
             :location/params {}}
            :class (cons "ml-2"
                         ui/button-secondary)}
           "Cancel"]])]])])

(defn render
  [state]
  (app-frame/app-frame
    state
    (panel state)))

(def page
  {:page-id :pages/totp-relation
   :route [["ui" "totp" "relation"]]
   :on-load (fn [location]
              (let [instagram-id (get-in location [:location/query-params :id])]
                [[:store/assoc :account/id instagram-id]
                 [:data/query core/totp-query]]))
   :render #'render})
